'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const JournalInfoCard = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));

export default JournalInfoCard;
